import { ArtifactVersionReadSchema } from '@/artifacts/schemas'
import { z } from 'zod'

// One row per draft: the artifact's latest COMPLETE version plus the conversation it came from.
export const GetDraftsByMatterIdResponseSchema = z.array(
  z.object({
    artifact_version: ArtifactVersionReadSchema,
    conversation_id: z.string().uuid(),
  })
)

export type GetDraftsByMatterIdResponse = z.infer<typeof GetDraftsByMatterIdResponseSchema>
